import { CRM } from "@/components/atomic-crm/root/CRM";
import logoDark from "./assets/cgap/logo_dark.svg";
import logoLight from "./assets/cgap/logo_light.svg";

const companySectors = [
  { value: "electric-utility", label: "Electric Utility / Co-op" },
  { value: "water-wastewater", label: "Water / Wastewater" },
  { value: "municipal", label: "Municipal / Government" },
  { value: "healthcare", label: "Hospital / Healthcare" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "warehousing", label: "Warehousing / Logistics" },
  { value: "construction", label: "Construction / Contractor" },
  { value: "telecom", label: "Telecom / Broadband" },
  { value: "marina", label: "Marina" },
  { value: "property", label: "Property Management" },
  { value: "school", label: "School / University" },
  { value: "distributor", label: "Safety Distributor / Reseller" },
  { value: "other", label: "Other" },
];

const dealStages = [
  { value: "new-lead", label: "New Lead" },
  { value: "contacted", label: "Contacted" },
  { value: "quote-sent", label: "Quote Sent" },
  { value: "follow-up", label: "Follow Up" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

const dealCategories = [
  { value: "website-order", label: "Website Order" },
  { value: "quote-request", label: "Quote Request" },
  { value: "bulk-order", label: "Bulk / Multi-Pack Order" },
  { value: "custom-signs", label: "Custom Signs" },
  { value: "amazon", label: "Amazon Customer" },
  { value: "outreach", label: "Cold Outreach" },
  { value: "other", label: "Other" },
];

const taskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "call", label: "Call" },
  { value: "follow-up", label: "Follow-up" },
  { value: "send-quote", label: "Send Quote" },
  { value: "ship", label: "Ship" },
  { value: "thank-you", label: "Thank you" },
];

const App = () => (
  <CRM
    title="CGAP CRM"
    darkModeLogo={logoDark}
    lightModeLogo={logoLight}
    companySectors={companySectors}
    dealStages={dealStages}
    dealPipelineStatuses={["won"]}
    dealCategories={dealCategories}
    taskTypes={taskTypes}
  />
);

export default App;
